import type { Partner } from "@expert/shared-types";
import { useQuery } from "@tanstack/react-query";
import { getCallIntroFlowQuestions } from "../api/getCallIntroFlowQuestions";
import { useContentfulClient } from "../ContentfulClientProvider";

export const useCallIntroFlowQuestions = (partner: Partner) => {
    const contentfulClient = useContentfulClient();
    const { data, error } = useQuery({
        queryKey: ["call-intro-flow-questions", partner],
        queryFn: async () => await getCallIntroFlowQuestions(contentfulClient, partner),
    });

    if (error) return undefined;

    return data;
};
